import axios from 'axios';

export const VoucherWaitingListApi = {
  getWaitingList: filter =>
    axios.get(`/api/self/paging/kindergarten_voucher_waiting_list?filter=${filter}`),
  getSignStringForWL: data =>
    axios.post(
      `/api/public/transitions/info/sign_string/kindergarten_voucher_waiting_list`,
      data
    ),
  addListWaiting: data =>
    axios.post(`/api/public/transitions/kindergarten_voucher_waiting_list`, data),
  changeDUO: data =>
    axios.put(`/api/public/transitions/kindergarten_voucher_waiting_list/change_do`, data)
};
